import { t } from 'i18next';
import { $api, $apiFetchClient } from './api';
import { hideSpinnerToast, showSpinnerToast } from '../utils/spinnerToaster';

export const getTermsByType = async (type: string) => {
  showSpinnerToast(t('terms.downloading_guidelines'));
  try {
    const resp = await $apiFetchClient.GET('/terms', {
      params: {
        query: {
          domain: `[("type_of_terms","=","${type}")]`,
        },
      },
      parseAs: 'blob',
    });
    return resp.data;
  } catch (error) {
    console.error(t('terms.downloading_error'));
    throw error;
  } finally {
    hideSpinnerToast();
  }
};

export const useTerm = (termId: number) => {
  const { data, isLoading } = $api.useQuery('get', '/terms/{term_id}', {
    params: {
      path: {
        term_id: termId,
      },
    },
  });

  return {
    term: data,
    isLoading,
  };
};
